import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IUpdateProductGoodsIssue } from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue";

import { date, number, string } from "yup";

export const getUpdateProductGoodsIssueSchema =
  (): ObjectSchemaType<IUpdateProductGoodsIssue> => ({
    id: {
      type: InputType.none,
    },
    exportDate: {
      type: InputType.datePicker,
      gridSize: 12,
      label: "Ngày nhập",
      validattionYupSchema: date().required(),
    },
    items: {
      arraySchema: {
        id: {
          type: InputType.none,
          defaultValue: "",
        },
        productId: {
          type: InputType.autoComplete,
          gridSize: 12,
          label: "Sản phẩm",
          validattionYupSchema: string().required(),
          metaData: createDomainPagedAutoCompleteMetaData("product"),
          defaultValue: "",
        },
        quantity: {
          type: InputType.number,
          gridSize: 6,
          label: "Số lượng",
          validattionYupSchema: number().required(),
          defaultValue: 0,
        },
        note: {
          type: InputType.textArea,
          gridSize: 12,
          label: "Ghi chú",
          validattionYupSchema: string(),
          defaultValue: "",
        },
      },
    },
  });
